module.exports = __webpack_public_path__ + "img/gente-que-gosta-de-gente.74df7ac6.jpg";